<template>
  <transition name="fade">
    <div v-if="hasError()" :class="[$style.errors, ifImpersonate ? $style.shiftErrorBox : '']" class="mt-notification">
      <ul>
        <li v-for="(error, i) in appErrors" :key="i" :class="$style.errorItem">
          <p v-html="$sanitize(error.message)" />
        </li>
      </ul>
      <button
        :id="$vId(this, 'hide')"
        class="mt-icon mt-icon-close"
        :class="[$style.skip, $style.close]"
        @click="hide()"
      />
    </div>
  </transition>
</template>

<script type="text/ecmascript-6">
import { mapGetters } from 'vuex'

export default {
  name: 'Errors',

  data () {
    return {
      appErrors: [],
      unsubscribe: null
    }
  },

  created () {
    this.setSubscription()
    this.setErrors()
  },

  beforeUnmount () {
    this.unsubscribe()
  },
  computed: {
    list () {
      return this.$store.getters['errors/list']
    },
    ifImpersonate (){
      return JSON.parse(window.localStorage.getItem('FS-Impersonate'))
    }
  },
  watch: {
    list: {
      handler(listArray) {
        for (let i = 0; i < this.list.length; i++) {
          setTimeout(this.hideErrors, 6000, i)
        }
      },
      deep: true
    }
  },

  created () {
    this.setSubscription()
    this.setErrors()
  },

  beforeUnmount () {
    this.unsubscribe()
  },
  methods: {
    hasError () {
      return this.appErrors.length > 0
    },
    hide () {
      this.$store.commit('errors/clear')
      this.setErrors()
    },
    setSubscription () {
      this.unsubscribe = this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'errors/add') {
          this.setErrors()
        }
      })
    },
    setErrors () {
      this.appErrors = this.$store.getters['errors/list']
    },
    hideErrors (index) {
      this.$store.commit('errors/clearOneByOne', this.appErrors[index])
      this.setErrors()
    }
  }
}
</script>

<style lang="scss" src="./stylesheets/index.scss" module></style>
